import { ChevronRight } from '@styled-icons/heroicons-outline/ChevronRight';
import { MatchesModalSchema } from '@/views/sports/components/MatchesModal/styles/MatchesModal.styles';

export const matchesModalStyles: MatchesModalSchema = {
  modalWrapper: { size: 'lg', isCentered: true, scrollBehavior: 'inside' },
  modalContent: { color: 'gray.600', overflow: 'hidden' },
  modalHeader: {
    color: 'gray.700',
    alignItems: 'center',
    borderBottom: '1px',
    borderColor: 'gray.200',
    display: 'flex',
    gap: '4',
    justifyContent: 'space-between',
    p: '4',
  },
  closeButton: {
    bg: 'gray.500',
    color: 'white',
    isRound: true,
    p: '1',
    size: 'xs',
    variant: 'link',
    _hover: { bg: 'gray.800' },
  },
  divider: { as: 'div', borderColor: 'gray.200' },
  modalBody: {
    p: '0',
    maxH: '400px',
    sx: {
      '::-webkit-scrollbar': {
        bgGradient: 'linear(to-b, zeta.400, zeta.600)',
        w: '6px',
      },
      '::-webkit-scrollbar-thumb': {
        bg: 'blackAlpha.500',
        borderRadius: 'xl',
      },
    },
  },
  stackWrapper: { spacing: '0' },
  linkWrapper: {
    alignItems: 'center',
    display: 'flex',
    gap: '3',
    justifyContent: 'space-between',
    p: '3',
    _hover: { bg: 'gray.100', textDecoration: 'none' },
  },
  flexSportName: {
    align: 'center',
    fontSize: 'sm',
    fontWeight: 'medium',
    gap: '1',
    color: 'gray.600',
  },
  iconSportName: { fontSize: '2xl', color: 'beta.800', sx: {} },
  hStack: { spacing: '1' },
  countdown: {
    fontWeight: 'bold',
    fontFamily: 'body',
    px: '2',
    py: '1',
    borderRadius: 'base',
    height: 'full',
    color: 'white',
    boxShadow: '0px 2px 4px 0px var(--bc-colors-blackAlpha-400)',
  },
  duotoneSgmLogoOverride: {
    h: 'auto',
    w: '9',
    sx: {
      svg: {
        color: 'delta.500',
      },
    },
  },
  hStackIcon: {
    as: ChevronRight,
    sx: {
      color: 'gray.500',
      fontSize: '2xl',
    },
  },
};
